export const PERMISSIONS = [
  { key: 'DASHBOARD_VIEW', label: 'Dashboard', description: 'Access the admin dashboard and summary.', category: 'Dashboard' },
  { key: 'PROPERTY_VIEW', label: 'Property View', description: 'View properties and approval queues.', category: 'Properties' },
  { key: 'PROPERTY_MANAGE', label: 'Property Manage', description: 'Create, edit, and publish properties.', category: 'Properties' },
  { key: 'BOOKING_VIEW', label: 'Booking View', description: 'View bookings and booking calendars.', category: 'Bookings' },
  { key: 'BOOKING_MANAGE', label: 'Booking Manage', description: 'Confirm and manage bookings.', category: 'Bookings' },
  { key: 'PAYMENT_VIEW', label: 'Payment View', description: 'View payment transactions and summaries.', category: 'Payments' },
  { key: 'PAYMENT_MANAGE', label: 'Payment Manage', description: 'Manage payments, refunds, and payment controls.', category: 'Payments' },
  { key: 'PAYOUT_MANAGE', label: 'Payout Manage', description: 'Manage host payouts and settlements.', category: 'Payments' },
  { key: 'HOST_VIEW', label: 'Host View', description: 'View host profiles and partner records.', category: 'Hosts/KYC' },
  { key: 'HOST_MANAGE', label: 'Host Manage', description: 'Manage host records and onboarding.', category: 'Hosts/KYC' },
  { key: 'KYC_VIEW', label: 'KYC View', description: 'View KYC submissions.', category: 'Hosts/KYC' },
  { key: 'KYC_MANAGE', label: 'KYC Manage', description: 'Approve or reject KYC submissions.', category: 'Hosts/KYC' },
  { key: 'SUPPORT_VIEW', label: 'Support View', description: 'View support tickets and customer messages.', category: 'Support' },
  { key: 'SUPPORT_MANAGE', label: 'Support Manage', description: 'Respond to and manage support queues.', category: 'Support' },
  { key: 'REPORT_VIEW', label: 'Report View', description: 'View operational and revenue reports.', category: 'Reports' },
  { key: 'BANNER_MANAGE', label: 'Banner Manage', description: 'Manage banners and homepage content blocks.', category: 'Content' },
  { key: 'BLOG_MANAGE', label: 'Blog Manage', description: 'Manage blogs and content pages.', category: 'Marketing' },
  { key: 'COUPON_MANAGE', label: 'Coupon Manage', description: 'Manage promotions and coupons.', category: 'Marketing' },
  { key: 'ROLE_MANAGE', label: 'Role Manage', description: 'View admin users, roles, and assignments.', category: 'Settings' },
  { key: 'SETTINGS_MANAGE', label: 'Settings Manage', description: 'Manage platform configuration.', category: 'Settings' },
  { key: 'API_MANAGE', label: 'API Manage', description: 'Manage provider APIs and sync settings.', category: 'API/Integrations' },
  { key: 'AUDIT_VIEW', label: 'Audit View', description: 'View admin audit logs.', category: 'Audit' },
  { key: 'EMAIL_VIEW', label: 'Email View', description: 'View Email Center dashboards, logs, and reports.', category: 'Email Center' },
  { key: 'EMAIL_MANAGE', label: 'Email Manage', description: 'Create templates, send campaigns, and manage queue retries.', category: 'Email Center' },
];

export const PERMISSION_KEYS = PERMISSIONS.map((permission) => permission.key);
export const ALL_PERMISSIONS = [...PERMISSION_KEYS];

export const normalizeRole = (role) =>
  String(role || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const isSuperAdminRole = (role) => normalizeRole(role) === 'MASTER_ADMIN' || normalizeRole(role) === 'SUPER_ADMIN';

const collectPermissions = (payload) => {
  const direct = payload?.permissions;
  const nested = payload?.admin?.permissions;
  const data = payload?.data?.permissions;
  return direct || nested || data || [];
};

const collectPrimaryRole = (payload) => {
  return (
    payload?.admin?.primaryRole?.roleCode ||
    payload?.admin?.primaryRole?.role_code ||
    payload?.primaryRole?.roleCode ||
    payload?.primaryRole?.role_code ||
    payload?.admin?.role?.roleCode ||
    payload?.admin?.role?.role_code ||
    payload?.admin?.role?.name ||
    payload?.admin?.role ||
    payload?.role ||
    ''
  );
};

export const resolvePermissionsFromPayload = (payload) => {
  const permissions = collectPermissions(payload);
  const adminType =
    payload?.admin?.adminType ||
    payload?.admin?.admin_type ||
    payload?.adminType ||
    payload?.admin_type ||
    '';
  const primaryRole = collectPrimaryRole(payload);
  const isSuperAdmin =
    Boolean(payload?.isSuperAdmin) ||
    Boolean(payload?.admin?.isSuperAdmin) ||
    normalizeRole(adminType) === 'MASTER_ADMIN' ||
    isSuperAdminRole(primaryRole);

  if (Array.isArray(permissions) && permissions.length) {
    return { permissions, isSuperAdmin };
  }
  if (isSuperAdmin) {
    return { permissions: ALL_PERMISSIONS, isSuperAdmin: true };
  }
  return { permissions: [], isSuperAdmin: false };
};
